import actions from './actions';

const {
    MARKETING_EXPENSES_DASHBOARD_BEGIN,
    MARKETING_EXPENSES_DASHBOARD_SUCCESS,
    MARKETING_EXPENSES_DASHBOARD_ERR,
    STORE_MARKETING_IMAGES_GALLERY_BEGIN,
    STORE_MARKETING_IMAGES_GALLERY_SUCCESS,
    STORE_MARKETING_IMAGES_GALLERY_ERR,
} = actions;

const initialState = { data: null, month: null, loading: false, error: null };

export const marketingExpensesDashboardReducer = (state = initialState, action) => {
    const { type, data, err, month } = action;
    switch (type) {
        case MARKETING_EXPENSES_DASHBOARD_BEGIN:
            return { ...initialState, month, loading: true };
        case MARKETING_EXPENSES_DASHBOARD_SUCCESS:
            return state.month === month ? { data, month, loading: false, error: null } : state;
        case MARKETING_EXPENSES_DASHBOARD_ERR:
            return state.month === month ? { data: null, month, loading: false, error: err } : state;
        default:
            return state;
    }
};

const galleryInitialState = { data: null, month: null, loading: true, error: null };

export const storeMarketingImagesGalleryReducer = (state = galleryInitialState, action) => {
    const { type, data, err, month } = action;
    switch (type) {
        case STORE_MARKETING_IMAGES_GALLERY_BEGIN:
            return { ...galleryInitialState, month, loading: true };
        case STORE_MARKETING_IMAGES_GALLERY_SUCCESS:
            return state.month === month ? { data, month, loading: false, error: null } : state;
        case STORE_MARKETING_IMAGES_GALLERY_ERR:
            return state.month === month ? { data: null, month, loading: false, error: err } : state;
        default:
            return state;
    }
};
